module.exports = __webpack_public_path__ + "images/emoji/clock730.7632d92520ef520ce4ac.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock730.png
// module id = CYFN
// module chunks = 24